import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessageBoxIcon, MessageBoxButtons } from '../messagebox.model';
import { MessageDialogComponent } from '../messagedialog/messagedialog.component';
import { Observable, of } from 'rxjs';
import { take, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class MessageBoxService {
    private isOpening = false;

    constructor(private readonly dialog: MatDialog) {}

    /**
     * Opens a message box. The caller must always subscribe to the observalble returned by this function.
     * Calling this function without subscribing will break this service and affect other dialogues as well.
     * @param inputData The data which is used to render the dialogue.
     * @returns Observable MatDialogRef.afterClosed which contains the result.
     */
    showMessageBox(inputData: {
        title: string;
        message: string;
        information: string;
        informationLine2?: string;
        icon: MessageBoxIcon;
        buttons: MessageBoxButtons;
        textForYes?: string;
        textForNo?: string;
        allowMultiplePopup?: boolean;
    }): Observable<any> {
        if (!this.isOpening || inputData.allowMultiplePopup) {
            this.isOpening = true;
            const dialogRef = this.dialog.open(MessageDialogComponent, {
                data: {
                    title: inputData.title,
                    message: inputData.message,
                    information: inputData.information,
                    informationLine2: inputData.informationLine2,
                    icon: inputData.icon,
                    buttons: inputData.buttons,
                    textForYes: inputData.textForYes,
                    textForNo: inputData.textForNo
                },
                panelClass: 'general-popup-container',
                backdropClass: 'general-dialog-backdrop'
            });
            // If the caller doesn't subscribe to this function call, then the following
            // code will not be executed, and {this.isOpening} will remain true preventing
            // other dialogues from being opened.
            return dialogRef.afterClosed().pipe(tap(() => (this.isOpening = false)));
        } else {
            return of().pipe(take(0));
        }
    }
}
